import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { TextField, Button, MenuItem, Switch, FormControlLabel } from '@material-ui/core';
import OverLoading from '../global/OverLoading';
import Constants from '../../common/constants';
import { addArea, deleteArea } from '../../actions/admin/areaAction';
import { updateModalContent, toggleModal } from '../../actions/modal';
import AreaMap from './areaMap';
import apiService from '../../services.js/apiService';

class Area extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading:         false,
      showAllDistrict: false,
      currentArea:     {
        name:    '',
        country: '',
        type:    '',
        coords:  [],
      },
    };
  }

  componentDidMount() {
    this.setState({ loading: true });
    if (this.props.area && !this.props.createAction) {
      this.setItems();
    } else {
      this.setState({ loading: false });
    }
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.area !== this.props.area) {
      if (this.props.area && !this.props.createAction) {
        const { id, name, country, type, coords } = this.props.area;
        this.setState({ currentArea: {
          id, name, country, type, coords,
        } }, () => {
          this.setState({ loading: false });
        });
      }
    }
  }

  setItems() {
    const { id, name, country, type, coords } = this.props.area;
    this.setState({ currentArea: {
      id, name, country, type, coords,
    } }, () => {
      this.setState({ loading: false });
    });
  }

  setMapData(coords) {
    this.setState({ currentArea: { ...this.state.currentArea, coords } });
  }

  onChange(e) {
    switch (e.target.name) {
      case `${e.target.name}`:
        this.setState({ currentArea: { ...this.state.currentArea, [e.target.name]: e.target.value } });
        break;
      default:
    }
  }

  onDelete() {
    this.props.updateModalContent({
      title:        'Are you sure?',
      content:      `This area '${this.state.currentArea.name}' will be deleted.`,
      actionButton: {
        actionText: 'Yes, Delete!',
        actionType: 'danger',
        action:     async () => {
          try {
            await this.props.deleteArea(this.state.currentArea.id);
            toast.success('Area deleted.');
            this.props.updateList();
          } catch (err) {
            toast.error(err.message);
          } finally {
            this.setState({ loading: false });
          }
        },
      },
      cancelText:       'No',
      closeAfterAction: true,
    });

    this.props.toggleModal();
  }

  async onSubmit(e) {
    e.preventDefault();
    this.setState({ loading: true });
    try {
      if (this.props.createAction) {
        await this.props.addArea(this.state.currentArea);
        toast.success('Area added.');
      } else {
        const { id } = this.state.currentArea;
        const updateRes = await apiService.updateArea(id, this.state.currentArea);
        if (updateRes) { toast.success('Area updated.'); }
      }
      this.props.updateList();

      this.setItems();
      this.setState({ loading: false });
    } catch (error) {
      toast.error(error.message);
      this.setState({ loading: false });
    }
  }

  render() {
    const { id, name, country, type } = this.state.currentArea;
    return (
      <>
        { this.state.loading && <OverLoading /> }
        <form
          className="form"
          onSubmit={(e) => this.onSubmit(e)}
          autoComplete="off"
        >
          <div className="container-fluid">
            <div className="form-group row">
              <div className="col-md-12">
                <h1 className="mb-3">{ this.props.createAction ? 'Create an Area' : 'Update Area' }</h1>
              </div>
            </div>

            { !this.props.createAction && (
              <div className="form-group row">
                <div className="col-md-12">
                  <div className="alert alert-primary" role="alert">
                    <b>Name</b>
                    {' '}
                    and
                    {' '}
                    <b>Country</b>
                    {' '}
                    cannot be updated. If the info(s) are wrong delete this Area and re-create.
                  </div>
                </div>
              </div>
            )}

            <div className="form-group row">
              <div className="col-md-12">
                <label htmlFor="area-name" className="col-form-label">Name</label>
                <TextField
                  id="area-name"
                  name="name"
                  className="form-control"
                  value={name || ''}
                  multiline
                  onChange={(e) => this.onChange(e)}
                  disabled={!this.props.createAction}
                />
              </div>
            </div>

            <div className="form-group row">
              <div className="col-md-6">
                <label htmlFor="select-country" className="col-form-label d-block">Country</label>
                <TextField
                  id="select-country"
                  name="country"
                  value={country || ''}
                  select
                  style={{ width: '100%' }}
                  onChange={(e) => this.onChange(e)}
                  disabled={!this.props.createAction}
                >
                  <MenuItem value="SG">SG</MenuItem>
                </TextField>
              </div>

              <div className="col-md-6">
                <label htmlFor="select-type" className="col-form-label d-block">Type</label>
                <TextField
                  id="select-type"
                  name="type"
                  value={type || ''}
                  placeholder="Select Type"
                  select
                  style={{ width: '100%' }}
                  onChange={(e) => this.onChange(e)}
                >
                  <MenuItem value={Constants.AreaType.Street}>{Constants.AreaType.Street}</MenuItem>
                  <MenuItem value={Constants.AreaType.SubDistrict}>{Constants.AreaType.SubDistrict}</MenuItem>
                  <MenuItem value={Constants.AreaType.District}>{Constants.AreaType.District}</MenuItem>
                  <MenuItem value={Constants.AreaType.MRT}>{Constants.AreaType.MRT}</MenuItem>
                  <MenuItem value={Constants.AreaType.Region}>{Constants.AreaType.Region}</MenuItem>
                  <MenuItem value={Constants.AreaType.Province}>{Constants.AreaType.Province}</MenuItem>
                </TextField>
              </div>
              <div className="col-md-6">
                {
                  type === Constants.AreaType.District && (
                    <FormControlLabel
                      control={<Switch checked={this.state.showAllDistrict} onChange={(e) => this.setState({ showAllDistrict: e.target.checked })} name="checkedA" />}
                      label="Show all district"
                    />
                  )
                }
              </div>
            </div>

            <div className="form-group row">
              <div className="col-md-12 mt-3 mb-3 p-0">
                <AreaMap
                  key={id}
                  areaType={type}
                  setMapCoor={(c) => this.setMapData(c)}
                  mapCoordinates={this.state.currentArea.coords}
                  districtsCoords={type === Constants.AreaType.District && this.state.showAllDistrict ? this.props.districtsCoords : []}
                />
              </div>
            </div>

            <div className="form-group row">
              <div className="col-md-12">
                <Button type="submit" variant="contained" className="float-left" color="primary" size="large">{ this.props.createAction ? 'Submit' : 'Update' }</Button>
                {!this.props.createAction && <Button variant="contained" className="float-right" color="secondary" size="large" onClick={() => this.onDelete()}>Delete</Button>}
              </div>
            </div>
          </div>
        </form>
      </>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  addArea:            (data) => dispatch(addArea(data)),
  deleteArea:         (id) => dispatch(deleteArea(id)),
  toggleModal:        () => dispatch(toggleModal()),
  updateModalContent: (data) => dispatch(updateModalContent(data)),
});

Area.propTypes = {
  createAction: PropTypes.bool.isRequired,
  area:         PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.array,
  ])),
  districtsCoords: PropTypes.arrayOf(PropTypes.array),

  deleteArea:         PropTypes.func.isRequired,
  toggleModal:        PropTypes.func.isRequired,
  addArea:            PropTypes.func.isRequired,
  updateList:         PropTypes.func.isRequired,
  updateModalContent: PropTypes.func.isRequired,
};

Area.defaultProps = {
  area:            [],
  districtsCoords: [],
};

export default connect(null, mapDispatchToProps)(Area);
